import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncHiring({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/hiring"));
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncHiring;
